import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconExchange = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.293 2.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L10.586 7H10a4 4 0 0 0-4 4v4.17a3.001 3.001 0 1 1-2 0V11a6 6 0 0 1 6-6h.586L9.293 3.707a1 1 0 0 1 0-1.414M16 6a3 3 0 1 1 4 2.83V13a6 6 0 0 1-6 6h-.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L13.414 17H14a4 4 0 0 0 4-4V8.83A3 3 0 0 1 16 6m3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
            clipRule="evenodd"
        />
    </svg>
);
